import { useCallback, useState } from 'react';
import { nodeContains } from '../../internal/utils/dom';
import styles from '../styles.css.js';
var MAX_HOVER_MARGIN = 6;
export function useMouseHover(_a) {
    var svgRef = _a.svgRef, scaledSeries = _a.scaledSeries, highlightPoint = _a.highlightPoint, isGroupNavigation = _a.isGroupNavigation, isPopoverPinned = _a.isPopoverPinned;
    var _b = useState(null), verticalMarkerLeft = _b[0], setVerticalMarkerLeft = _b[1];
    var onSVGMouseMove = useCallback(function (event) {
        if (event.target !== svgRef.current || scaledSeries.length === 0 || isPopoverPinned || isGroupNavigation) {
            return;
        }
        var svgRect = event.target.getBoundingClientRect();
        var offsetX = event.clientX - svgRect.left;
        var offsetY = event.clientY - svgRect.top;
        var closestX = scaledSeries
            .map(function (v) { return v.x; })
            .reduce(function (prev, curr) { return (Math.abs(curr - offsetX) < Math.abs(prev - offsetX) ? curr : prev); }, -Infinity);
        var closestY = scaledSeries
            .filter(function (v) { return v.x === closestX || v.series.type === 'threshold'; })
            .map(function (v) { return v.y; })
            .reduce(function (prev, curr) { return (Math.abs(curr - offsetY) < Math.abs(prev - offsetY) ? curr : prev); }, -Infinity);
        if (isFinite(closestX)) {
            setVerticalMarkerLeft(closestX);
            if (isFinite(closestY) &&
                Math.abs(offsetX - closestX) < MAX_HOVER_MARGIN &&
                Math.abs(offsetY - closestY) < MAX_HOVER_MARGIN) {
                var _a = scaledSeries.filter(function (s) { return (s.x === closestX || s.series.type === 'threshold') && s.y === closestY; })[0], color = _a.color, datum = _a.datum, series = _a.series;
                highlightPoint({ x: closestX, y: closestY, color: color, datum: datum, series: series });
            }
            else {
                highlightPoint(null);
            }
        }
    }, [svgRef, scaledSeries, isPopoverPinned, isGroupNavigation, highlightPoint]);
    var onSVGMouseOut = useCallback(function (event) {
        if (isPopoverPinned || isGroupNavigation) {
            return;
        }
        if (!nodeContains(svgRef.current, event.relatedTarget) ||
            // `classList` is not supported on IE11 for SVG elements
            ((event.relatedTarget && event.relatedTarget.getAttribute('class')) || '')
                .split(' ')
                .indexOf(styles.series) > -1) {
            setVerticalMarkerLeft(null);
        }
    }, [isPopoverPinned, isGroupNavigation, svgRef]);
    return { verticalMarkerLeft: verticalMarkerLeft, onSVGMouseMove: onSVGMouseMove, onSVGMouseOut: onSVGMouseOut };
}
//# sourceMappingURL=use-mouse-hover.js.map